<script lang="ts">
  export let size: 'sm' | 'md' = 'sm';
  export let emphasis: 'low' | 'medium' | 'high' = 'low';
  export let content = '';
</script>

<div
  class:low={emphasis == 'low'}
  class:medium={emphasis == 'medium'}
  class:high={emphasis == 'high'}
  class:sm={size == 'sm'}
  class:md={size == 'md'}
  class="font-architekt flex items-center justify-center rounded text-xs leading-4 {$$props.class}"
>
  <span>
    {content}
  </span>
</div>

<style lang="postcss">
  .low {
    @apply bg-gray-dark-2 text-gray-dark-12;
  }
  .medium {
    @apply bg-gray-dark-12 text-gray-dark-0;
  }

  .high {
    @apply bg-red-dark-9 text-red-dark-12;
  }
  .sm {
    @apply px-md h-8;
  }
  .md {
    @apply px-lg h-10;
  }
</style>
